import { PageHeader } from "@/components/common/States";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useAuth, useSpaceName } from "@/context/AuthContext";
import { ROLE_LABELS } from "@/lib/labels";
import { PasswordForm, ProfileCard } from "@/components/settings/AccountSettings";

export default function SchoolSettings() {
  const { me } = useAuth();
  const space = useSpaceName();
  const profil = [
    { label: "Nama", value: me.user.full_name },
    { label: "Peran", value: ROLE_LABELS[me.active_school?.role] },
    { label: "Sekolah", value: me.active_school?.school_name },
    { label: "Email akun (login)", value: me.user.email, mono: true },
  ];
  return (
    <div className="space-y-6">
      <PageHeader eyebrow={space} title="Pengaturan"
        description="Lihat profil akun Anda dan atur kata sandi untuk masuk ke SIST." />
      <Tabs defaultValue="profil" data-testid="school-settings-tabs">
        <TabsList>
          <TabsTrigger value="profil" data-testid="settings-tab-profile">Profil</TabsTrigger>
          <TabsTrigger value="sandi" data-testid="settings-tab-password">Reset Kata Sandi</TabsTrigger>
        </TabsList>
        <TabsContent value="profil" className="mt-4">
          <ProfileCard fields={profil}
            description="Nama, peran, dan sekolah mengikuti data keanggotaan Anda. Hubungi admin sekolah bila ada yang perlu diperbaiki." />
        </TabsContent>
        <TabsContent value="sandi" className="mt-4"><PasswordForm /></TabsContent>
      </Tabs>
    </div>
  );
}
